export default __webpack_public_path__ + "static/game-choice-score-e017da89d6806954b27f35ef92af5348.png";